import { Typography } from "@mui/material";
import { Box } from "@mui/system";
import { HeadingLevel } from "@/core/types/types";
import Field from "@/core/components/Field";
import { useTranslations as t } from "@/core/hooks/useTranslations/useTranslations";
import { fields, FieldName } from "./fields";

interface CaseSummaryEditProps {
  customerFirstName: string;
  customerLastName: string;
}

const CaseSummaryEdit = ({
  customerFirstName,
  customerLastName,
}: CaseSummaryEditProps) => {
  return (
    <div>
      <Box my={2}>
        <Typography variant={HeadingLevel.H2}>
          {t("contactInformation.label")}
        </Typography>
      </Box>

      <Box display="flex" mt={2}>
        <Box mr={1} width={1}>
          <Field
            field={fields[FieldName.CustomerFirstName]}
            initialValue={customerFirstName}
          />
        </Box>

        <Field
          field={fields[FieldName.CustomerLastName]}
          initialValue={customerLastName}
        />
      </Box>
    </div>
  );
};

export { CaseSummaryEdit };
